import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { store } from '../../store';
import Moment from 'moment';
import { isObject, omit, startCase } from 'lodash';

import api from '../../store/api/api';
import { setFocusedMembership } from '../../store/api/calls';

import FloatHeader from '../theme/headers/FloatHeader';

import { getUUID } from '../../utils/hashAndUuid';
import FeedbackTile from '../theme/modals/FeedbackTile';
import BaseModal from '../theme/modals/BaseModal';
import BaseForm from '../theme/forms/BaseForm';
import ScriptDisplay from '../theme/scripts/scriptDisplay';
import Input from '../theme/forms/Input';
import RandomizerForm from './RandomizerForm';
import VoterLookupForm from './VoterLookupForm';
import VoterRoutedForm from './VoterRoutedForm';
import { withRouter } from '../../utils/withRouter';
import { Checkbox, FormControlLabel, TextField } from '@mui/material';

//form for creating script elements
class CreateElementForm extends Component {
  static defaultProps = {
    editing_element: {},
    script_elements: [],
    onSubmit: () => null,
    onCancel: () => null,
  };

  constructor(props) {
    super(props);
    const elementTypeName =
      props?.editing_element?.elementtype ||
      props?.editing_element?.element_type_config?.name;
    const isSpeechElement = elementTypeName === 'speech';

    this.defaultInputs = [
      {
        type: 'text',
        title: 'Name',
        dataKey: 'display_name',
        placeholder: 'Use something descriptive',
        value: props?.editing_element?.display_name,
      },
      {
        type: isSpeechElement ? 'textarea' : 'text',
        title: 'Prompt',
        dataKey: 'prompt',
        placeholder: '',
        value: props?.editing_element?.prompt,
        ...(isSpeechElement && { rows: 8 }),
      },
    ];

    this.state = {
      inputs: [...this.defaultInputs],
      editing_element: {},
      attribsInputForJson: '',
    };

    this.form = React.createRef();
    this.scriptDisplayRef = React.createRef();
  }

  componentDidMount() {
    //we need to move editing_element to state, because we update that value dynamically.
    let { editing_element } = this.props;

    //element came from a creation button. We define the basics here.
    if (!editing_element.element_hash) {
      editing_element = {
        ...editing_element,
        display_name: startCase(editing_element.element_type_config?.name),
        element_hash: getUUID().split('-')[0],
        ...this.getNewElementDefaultPosition(),
        prompt: '',
        elementtype: editing_element.element_type_config?.name,
        iconClass: editing_element.element_type_config?.iconClass,
        connectors: [],
      };
    }

    const attribsInputUsesJson =
      editing_element.element_type_config?.attribsInputJson === true;

    if (attribsInputUsesJson) {
      const existing = editing_element.attribs;
      editing_element = {
        ...editing_element,
        attribs:
          isObject(existing) && !Array.isArray(existing) ? existing : {},
      };
    }

    this.setState(
      {
        editing_element,
        ...(attribsInputUsesJson && {
          attribsInputForJson: JSON.stringify(
            editing_element.attribs || {},
            null,
            2
          ),
        }),
      },
      () => {
        if (editing_element.element_type_config.defineResponses) {
          this.addResponseInput();
        }
      }
    );
  }

  onAttribsInputForJsonChange = (e) => {
    const text = e.target.value;
    this.setState({ attribsInputForJson: text });
    try {
      const parsed = JSON.parse(text);
      if (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)) {
        this.onValueChange('attribs', parsed);
      }
    } catch (_) {
      /* keep draft text; attribs left at last valid parse */
    }
  };

  renderRandomizer() {
    const element = this.props.editing_element.elementtype
      ? this.props.editing_element
      : {
          display_name: startCase(this.props.editing_element.element_type_config.name),
          element_hash: getUUID().split('-')[0],
          ...this.getNewElementDefaultPosition(),
          prompt: '',
          elementtype: this.props.editing_element.element_type_config.name,
          iconClass: this.props.editing_element.element_type_config.iconClass,
          connectors: [],
        };
    return (
      <RandomizerForm
        element={element}
        onSubmit={this.props.onSubmit}
        onCancel={this.props.onCancel}
        onDeleteElement={this.props.onDeleteElement}
      />
    );
  }

  renderVoterLookup() {
    const element = this.props.editing_element.elementtype
      ? this.props.editing_element
      : {
          display_name: startCase(this.props.editing_element.element_type_config.name),
          element_hash: getUUID().split('-')[0],
          ...this.getNewElementDefaultPosition(),
          prompt: this.props.editing_element?.prompt || '',
          attribs: this.props.editing_element?.attribs || {
            check_prior_voter_selection: true,
            allow_selection_of_prior_selected_voter: true,
          },
          elementtype: this.props.editing_element.element_type_config.name,
          iconClass: this.props.editing_element.element_type_config.iconClass,
          connectors: [],
        };

    const WrapperElement =
      this.props.editing_element.elementtype === 'voterrouted' ||
      this.props.editing_element?.element_type_config?.name === 'voterrouted'
        ? VoterRoutedForm
        : VoterLookupForm;

    return (
      <WrapperElement
        element={element}
        onSubmit={this.props.onSubmit}
        onCancel={this.props.onCancel}
        onDeleteElement={this.props.onDeleteElement}
      />
    );
  }

  getNewElementDefaultPosition = () => {
    const validTops = this.props.script_elements
      .map((d) => Number(d.pos_top))
      .filter((v) => Number.isFinite(v));

    const validLefts = this.props.script_elements
      .map((d) => Number(d.pos_left))
      .filter((v) => Number.isFinite(v));

    const baseTop = validTops.length ? Math.max(...validTops) : 100;
    const baseLeft = validLefts.length ? Math.max(...validLefts) : 100;

    return {
      pos_top: baseTop + 80,
      pos_left: baseLeft + 80,
    };
  };

  getResponseOptionDataKey = (index) => `response__${index}`;

  getResponseOptionTitle = (index) => {
    return (
      <div className={'m-0 full-width flx space_between'}>
        <span>Response Option {index + 1}</span>
        {/* only show this if there is more than one response option*/}
        <i
          className={'danger-text fas fa-minus-circle is-clickable mr-1'}
          onClick={(e) => {
            e.stopPropagation();
            this.removeResponseInput(index);
          }}
        />
      </div>
    );
  };

  addResponseInput = (adding = false) => {
    // this is a new element that we are creating

    let newInputs = [...this.state.inputs];

    if (!this.props?.editing_element?.connectors || adding) {
      let curr_index = this.state.inputs.length - this.defaultInputs.length; // length of inputs, minus the two that are there (name and prompt)
      this.addResponseOptionToEditingElement();
      newInputs.push({
        type: 'text',
        title: this.getResponseOptionTitle(curr_index),
        dataKey: this.getResponseOptionDataKey(curr_index),
        resp_idx: curr_index,
        placeholder: '',
      });
      // loading an existing element, normally called on mount
    } else {
      this.props.editing_element.connectors.forEach((c, i) => {
        newInputs.push({
          type: 'text',
          title: this.getResponseOptionTitle(i),
          dataKey: this.getResponseOptionDataKey(i),
          resp_idx: i,
          value: c.value_text,
        });
      });
    }
    this.setState({
      inputs: newInputs,
    });
  };

  addResponseOptionToEditingElement = () => {
    let { editing_element } = this.state;

    // we default the connection to the next element hash of the connector in front of it.
    let next_el_hash =
      editing_element.connectors?.[editing_element.connectors.length - 1]?.next_el_hash;

    editing_element.connectors.push({
      ordinal_position: editing_element.connectors.length + 1,
      value_text: null,
      next_el_hash,
      key: null, // key updates when we have a value
    });
  };

  removeResponseInput = (resp_idx) => {
    let { inputs, editing_element } = this.state;

    if (editing_element.connectors.length === 1) {
      this.setState({
        errMsg: 'You must have at least one response for this element.',
      });
      setTimeout(() => this.setState({ errMsg: null }), 2000);
      return;
    }

    //filter and reupdate their ordinal keys.
    inputs = inputs
      .filter((d, i) => d.dataKey !== this.getResponseOptionDataKey(resp_idx))
      .map((d, i) => {
        if (i < this.defaultInputs.length) return d;
        let resp_idx = i - this.defaultInputs.length;
        return {
          ...d,
          resp_idx,
          title: this.getResponseOptionTitle(resp_idx),
          dataKey: this.getResponseOptionDataKey(resp_idx),
        };
      });

    //filter out editing element and update the keys to force a refresh react side.
    editing_element.connectors = editing_element.connectors
      .filter((d, i) => i !== resp_idx)
      .map((d) => ({
        ...d,
        key: d.key + '-' + Math.round(Math.random() * 10000000),
      }));

    // to do : editing_element is not in state, it's in props. =P
    this.setState({
      inputs,
      editing_element,
    });
  };

  onValueChange = (dataKey, val) => {
    let { editing_element } = this.state;

    if (dataKey.startsWith('response__')) {
      let resp_idx = +dataKey.split('__')[1];
      if (isNaN(resp_idx)) {
        console.error('Unable to get the index of the updated response. DataKey: ', dataKey);
        return;
      }

      let targetResp = editing_element?.connectors[resp_idx];
      if (!targetResp || !isObject(targetResp)) {
        console.error('Could not find target response on update');
        return;
      }

      targetResp = {
        ...targetResp,
        value_text: val,
        key: `${val}-${editing_element.element_hash}`,
      };
      editing_element.connectors[resp_idx] = targetResp;
    } else {
      editing_element[dataKey] = val;
    }

    this.setState({ editing_element });
  };

  onCreateElementSubmit = () => {
    let editing_element = { ...this.state.editing_element };
    const cfg = editing_element.element_type_config;

    if (cfg?.attribsInputJson === true) {
      try {
        const parsed = JSON.parse(this.state.attribsInputForJson || '{}');
        editing_element.attribs =
          parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)
            ? parsed
            : {};
      } catch {
        editing_element.attribs =
          isObject(this.state.editing_element.attribs) &&
          !Array.isArray(this.state.editing_element.attribs)
            ? this.state.editing_element.attribs
            : {};
      }
    }

    //filter our elements without values
    editing_element.connectors = editing_element.connectors.filter(
      (d) => d.value_text && d.value_text.length
    );

    this.props.onSubmit(omit(editing_element, ['element_type_config']));
  };

  render() {
    if (
      this.props.editing_element.elementtype === 'randomizer' ||
      this.props.editing_element?.element_type_config?.name === 'randomizer'
    ) {
      return this.renderRandomizer();
    }
    if (
      this.props.editing_element.elementtype === 'voter_lookup' ||
      this.props.editing_element?.element_type_config?.name === 'voter_lookup'
    ) {
      return this.renderVoterLookup();
    }
    if (
      this.props.editing_element.elementtype === 'voterrouted' ||
      this.props.editing_element?.element_type_config?.name === 'voterrouted'
    ) {
      return this.renderVoterLookup();
    }

    let element_type_config = this.props.editing_element.element_type_config;

    let otherButtons = this.props.editing_element.element_hash
      ? [
          <button type={'button'} className={'button danger'} onClick={this.props.onDeleteElement}>
            Delete Element
          </button>,
        ]
      : [];

    return (
      <>
        <div className={'mx-5 mb-4 is-border-underlined'}>
          <h6 className={'m-0 pb-2'}>
            <i className={element_type_config.iconClass + ' mr-3'} />
            Add a {startCase(element_type_config.name)} element
          </h6>
        </div>
        {this.state.errMsg && (
          <p className={'danger-text mx-1 mx-5 is-size-6'}>{this.state.errMsg}</p>
        )}

        <BaseForm
          ref={this.form}
          className={'my-0 sidebar-form'}
          inputs={this.state.inputs}
          onCancel={this.props.onCancel}
          onSubmit={this.onCreateElementSubmit}
          onValueChange={this.onValueChange}
          otherButtons={otherButtons}
        >
          {element_type_config.defineResponses && (
            <div className={'button-wrapper mb-2'}>
              <div
                className={'button button-clear m-0 pl-0'}
                onClick={() => this.addResponseInput(true)}
              >
                + Response Option
              </div>
            </div>
          )}

          {element_type_config.attribsInput &&
            (element_type_config.attribsInputJson ? (
              <TextField
                className="mb-2 mt-3"
                fullWidth
                multiline
                minRows={4}
                label="Attributes (JSON)"
                helperText='Enter the attributes for the element in JSON format. For example: {"limit":21,"radius":50,"radius_units":"feet"}'
                placeholder='{"limit":20,"radius":50,"radius_units":"feet"}'
                value={this.state.attribsInputForJson}
                onChange={this.onAttribsInputForJsonChange}
                variant="outlined"
                size="small"
              />
            ) : (
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={
                      this.state.editing_element['attribs']
                        ? this.state.editing_element['attribs']['controls']
                        : false
                    }
                    onChange={(e, val) => this.onValueChange('attribs', { controls: val })}
                    color="primary"
                  />
                }
                label="Show Controls"
              />
            ))}
        </BaseForm>
      </>
    );
  }
}

class ScriptEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      errMsg: "Doesn't work yet.",
      editing_element: null,
      script_metadata: {},
      script_elements: [],
      script_revisions: [],
      displayed_revision: null,
      copyModalOpen: false,
      copyTargetCampaign: props.focusedCampaign?.id,
      copyName: '',
      copying: false,
    };

    this.elementTypes = [
      {
        id: 1,
        name: 'speech',
        iconClass: 'fas fa-quote-left',
      },
      {
        id: 2,
        name: 'question',
        iconClass: 'fas fa-question',
        defineResponses: true,
      },
      {
        id: 4,
        name: 'phone',
        iconClass: 'fas fa-phone',
      },
      {
        id: 5,
        name: 'email',
        iconClass: 'fas fa-at',
      },
      {
        id: 6,
        name: 'text',
        iconClass: 'fas fa-pencil-alt',
      },
      {
        id: 7,
        name: 'signature',
        iconClass: 'fas fa-signature',
      },
      {
        id: 8,
        name: 'barcode',
        iconClass: 'fas fa-barcode',
      },
      {
        id: 17,
        name: 'image',
        iconClass: 'far fa-image',
        attribsInput: true,
        attribsInputJson: true,
      },
      {
        id: 21,
        name: 'audio',
        iconClass: 'fas fa-microphone',
      },
      {
        id: 18,
        name: 'docscan',
        iconClass: 'far fa-file-alt',
      },
      /* 
                   {
                    id: 20,
                    name: 'docscan_w_barcode',
                    iconClass: 'far fa-file-alt',
                  }, */
      {
        id: 19,
        name: 'multiselect',
        iconClass: 'far fa-list-alt',
        defineResponses: true,
      },
      {
        id: 22,
        name: 'web_link_qr',
        iconClass: 'fa fa-qrcode',
        defineResponses: false,
      },
      {
        id: 23,
        name: 'randomizer',
        iconClass: 'fas fa-random',
        defineResponses: true,
        defineWeights: true,
      },
      {
        id: 24,
        name: 'voter_lookup',
        iconClass: 'fas fa-address-book',
        defineResponses: false,
      },
      {
        id: 25,
        name: 'voterrouted',
        iconClass: 'fas fa-random',
        defineResponses: true,
        defineWeights: true,
      },
      {
        id: 27,
        name: 'audio_start',
        iconClass: 'fas fa-headphones',
        attribsInput: true,
      },
      {
        id: 28,
        name: 'audio_end',
        iconClass: 'fas fa-headphones',
      },
      {
        id: 29,
        name: 'nearest_neighbor',
        iconClass: 'fas fa-map-marker-alt',
        attribsInput: true,
        attribsInputJson: true,
      },
      {
        id: 30,
        name: 'contact',
        iconClass: 'fas fa-address-card',
      },
    ];
  }

  componentDidMount() {
    this.loadScript(this.props.params.script_id);
  }

  componentDidUpdate(prevProps) {
    // When we navigate to a freshly-cloned script the route param changes but
    // this component instance is reused, so reload the new script's data.
    if (prevProps.params.script_id !== this.props.params.script_id) {
      this.setState({ editing_element: null });
      this.loadScript(this.props.params.script_id);
    }
  }

  loadScript = (script_id) => {
    this.setState({ loading: true });
    api
      .get('/script/', { s: script_id })
      .then((res) => {
        console.log(res.data);
        this.onLoadScriptData(res.data);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
    // this.onLoadScriptData(sampleData)
  };

  _isError = () => {
    return this.state.error;
  };

  _isLoading = () => {
    return this.state.loading;
  };

  onCreateElementRequest = (element_type_config) => {
    this.setState({
      editing_element: { element_type_config },
    });
  };

  onEditElementRequest = (element) => {
    //set to null and then back to make sure it updates if we were just updating another element.
    this.setState({ editing_element: null }, () =>
      this.setState({
        editing_element: {
          ...element,
          element_type_config: this.elementTypes.find((d) => d.name === element.elementtype) || {},
        },
      })
    );
  };

  onLoadScriptData = (script_data, revision_only = false) => {
    let script_metadata = script_data.script;
    let script_revisions = script_data.drafts;

    this.onLoadRevision(script_data.revision);

    this.setState({
      script_metadata,
      script_revisions,
      displayed_revision: script_metadata.draft_revision_id,
    });
  };

  onLoadRevision = (revision_data) => {
    const script_elements = revision_data.script_schema.map((d) => {
      // START node (special)
      if (d.elementtype === 'start') {
        return {
          ...d,
          iconClass: 'fas fa-play-circle',
          isStart: true,
          pos_top: Number.isFinite(+d.pos_top) ? d.pos_top : 100,
          pos_left: Number.isFinite(+d.pos_left) ? d.pos_left : 100,
          connectors: d.connectors || [],
        };
      }

      // Normal nodes
      const match = this.elementTypes.find((e) => e.name === d.elementtype);

      return {
        ...d,
        iconClass: match?.iconClass,
        elementtype_id: match?.id,
        pos_top: Number.isFinite(+d.pos_top) ? d.pos_top : 100,
        pos_left: Number.isFinite(+d.pos_left) ? d.pos_left : 100,
        connectors: d.connectors || [],
      };
    });

    this.setState({ script_elements });
  };

  onSaveRevisionRequest = () => {
    this.setState({ loading: true });
    api
      .post('/script/', {
        schema: this.state.script_elements.map((el) =>
          omit(el, ['element_type_config'])
        ),
        script_id: this.state.script_metadata.id,
      })
      .then((res) => {
        this.setState({
          script_revisions: [res.data, ...this.state.script_revisions],
          displayed_revision: res.data.id,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  /* -----------------------------
   * Copy Script
   * ----------------------------- */

  onOpenCopyModal = () => {
    this.setState({
      copyModalOpen: true,
      copyTargetCampaign:
        this.state.copyTargetCampaign || this.props.focusedCampaign?.id,
      copyName: `${this.state.script_metadata.name || 'Script'} Copy`,
    });
  };

  onCloseCopyModal = () => {
    this.setState({ copyModalOpen: false });
  };

  onCopyScriptSubmit = () => {
    const { copyTargetCampaign, copyName } = this.state;
    if (!copyTargetCampaign) return;

    this.setState({ copying: true });
    api
      .post('/script/copy/', {
        script_id: this.state.script_metadata.id,
        target_campaign_id: copyTargetCampaign,
        source_revision_id: this.state.displayed_revision,
        name: copyName,
      })
      .then((res) => {
        const { script_id, campaign_id } = res.data;
        // Switch focus to the target campaign so subsequent calls (and the
        // auto-injected campaign param) line up with the new script.
        if (campaign_id && campaign_id !== this.props.focusedCampaign?.id) {
          setFocusedMembership(campaign_id);
        }
        this.setState({ copyModalOpen: false });
        this.props.navigate(`/script/${script_id}/edit`);
      })
      .catch((err) => {
        console.error('Failed to copy script', err);
        this.setState({ error: true, errMsg: 'Failed to copy the script.' });
        setTimeout(() => this.setState({ error: false }), 4000);
      })
      .finally(() => {
        this.setState({ copying: false });
      });
  };

  onCreateEditElementSubmit = (element) => {
    this.setState((prev) => {
      const idx = prev.script_elements.findIndex((d) => d.element_hash === element.element_hash);

      let script_elements;
      if (idx >= 0) {
        script_elements = prev.script_elements.map((d, i) => (i === idx ? { ...element } : d));
      } else {
        script_elements = [...prev.script_elements, { ...element }];
      }

      return {
        editing_element: null,
        script_elements,
      };
    });
  };

  onDeleteElement = () => {
    let { script_elements: ses, editing_element: element } = this.state;

    ses = ses.filter((d) => d.element_hash !== element.element_hash);
    ses.forEach((d) => {
      d.connectors = d.connectors.map((c) =>
        c.next_el_hash === element.element_hash ? { ...c, next_el_hash: null } : c
      );
    });

    this.setState({ script_elements: ses, editing_element: null });
  };

  onDeleteResponseOption = (element_hash, connector) => {};

  handleElementMove = (element_hash, x, y) => {
    this.setState((prev) => ({
      script_elements: prev.script_elements.map((d) =>
        d.element_hash === element_hash ? { ...d, pos_left: x, pos_top: y } : d
      ),
    }));
  };

  _renderCreationButtons = () => {
    return (
      <>
        <div className={`side-menu-list-obj`}>
          <h6>
            Click on an element type below to add it. Double click on an existing element to edit
            it.{' '}
          </h6>
        </div>
        {this.elementTypes.map((d) => (
          <div
            className={`side-menu-list-obj`}
            key={d.name}
            onClick={() => this.onCreateElementRequest(d)}
            // onMouseEnter={this.props.onMouseEnter}
            // onMouseLeave={this.props.onMouseLeave}
          >
            <div className="list-obj-inner-wrapper" style={{ borderLeftColor: 'transparent' }}>
              <div className="obj-title">
                <i className={d.iconClass + ' mr-3'} />
                {d.name === 'voterrouted' ? 'Voter Routed' : startCase(d.name)}
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  _renderMenuBody = () => {
    if (this.state.editing_element) {
      return (
        <CreateElementForm
          {...this.state}
          onSubmit={this.onCreateEditElementSubmit}
          onCancel={() => this.setState({ editing_element: null })}
          onDeleteElement={this.onDeleteElement}
        />
      );
    } else {
      return this._renderCreationButtons();
    }
  };

  _getRevisionsSelector = () => {
    return (
      <Input
        className={'m-0'}
        type={'select'}
        options={this.state.script_revisions.map((d) => ({
          value: d.id,
          display: `${
            this.state.script_metadata.pub_revision_id === d.id ? '[ PUBLISHED ] ' : ''
          }Revision ${d.revision_num}   (${new Moment(d.created_at).format('MM/DD LT')})`,
        }))}
        value={this.state.displayed_revision}
        onChange={this._handleRevisionSelection}
      />
    );
  };

  _handleRevisionSelection = (revision_id) => {
    // the select gives us a string; keep it numeric so comparisons against
    // pub_revision_id / draft_revision_id (numbers) stay accurate.
    this.setState({ displayed_revision: Number(revision_id) });

    api.get('/script-get-schema/', { sr: revision_id }).then((res) => {
      this.onLoadRevision(res.data);
    });
  };

  _renderMenu = () => {
    return (
      <div className={`map-side-menu ${this.state.sideBarClosed && 'closed'}`}>
        <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
          <div className="side-menu-title">
            <p className={'m-0'}>Editing Script</p>
            <h3 className={'primary-text mb-4'}>{this.state.script_metadata.name}</h3>
            {this._getRevisionsSelector()}
            <div className={'flx space_between align-center'}>
              <div
                className={`button button-clear m-0 p-0 align`}
                onClick={this.onOpenCopyModal}
              >
                <i className={'far fa-copy mr-2'} />
                Copy Script
              </div>
              <div
                className={`button button-clear m-0 p-0 align ${
                  this._isLoading() ? 'disabled' : ''
                }`}
                onClick={this.onSaveRevisionRequest}
              >
                Save
              </div>
            </div>
          </div>
          <div className={'side-menu-body'}>{this._renderMenuBody()}</div>
        </div>

        <div className={`side-menu-select-wrapper`} style={{ width: '1px' }}>
          {/*<div className={'side-menu-option'}>*/}
          {/*    <Link to={'/site-list'}>*/}
          {/*        <div*/}
          {/*            className={'button primary-milligram'}*/}
          {/*            onClick={() => null}*/}
          {/*        >*/}
          {/*            Response View*/}
          {/*        </div>*/}
          {/*    </Link>*/}
          {/*</div>*/}

          {this.state.loading && (
            <div className={`side-menu-option loading`}>
              <i className="fas fa-asterisk" />
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <FloatHeader link="/script" />

        <div className={'polka-back script-edit-wrapper script-display-root'}>
          <ScriptDisplay
            data={this.state.script_elements}
            is_editable={true}
            onEditElementRequest={this.onEditElementRequest}
            editingElement={this.state.editing_element}
            onElementMove={this.handleElementMove}
            onLinkElementComplete={(updatedData) => {
              this.setState({ script_elements: updatedData });
            }}
          />
        </div>

        {this._renderMenu()}

        {this._isError() && (
          <FeedbackTile
            text={
              <div>
                <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
                {this.state.errMsg}
              </div>
            }
            visible={true}
            classNames="danger clear-sidebar-feedback-tile"
          />
        )}

        {/* COPY SCRIPT MODAL */}
        <BaseModal
          title="Copy Script"
          open={this.state.copyModalOpen}
          onClose={this.onCloseCopyModal}
          loading={this.state.copying}
          center
        >
          <div className="modal-internal-wrapper mx-5">
            <p className={'mb-2'}>
              Copy <b>{this.state.script_metadata.name}</b> (and all its elements,
              connectors, and attributes) into a campaign.
            </p>

            {this.state.displayed_revision !==
              this.state.script_metadata.pub_revision_id && (
              <p className={'mb-3'} style={{ color: '#b7791f' }}>
                <i className={'fas fa-exclamation-triangle mr-2'} />
                The revision you are viewing is not the published one. The copy
                will be made from this active revision.
              </p>
            )}

            <label className={'is-size-7 mb-1'}>Script Name</label>
            <Input
              className={'m-0 mb-3'}
              type={'text'}
              value={this.state.copyName}
              onChange={(val) => this.setState({ copyName: val })}
            />

            <label className={'is-size-7 mb-1'}>Target Campaign</label>
            <Input
              className={'m-0 mb-4'}
              type={'select'}
              options={(this.props.campaigns || []).map((c) => ({
                value: c.id,
                display: c.name,
              }))}
              value={this.state.copyTargetCampaign}
              onChange={(val) => this.setState({ copyTargetCampaign: +val })}
            />

            <div className="button-wrapper">
              <div
                className={`button ${this.state.copying ? 'disabled' : ''}`}
                onClick={this.onCopyScriptSubmit}
              >
                Copy
              </div>
              <div
                className="button button-outline"
                onClick={this.onCloseCopyModal}
              >
                Cancel
              </div>
            </div>
          </div>
        </BaseModal>

        {/*<BaseModal*/}
        {/*    title={`Edit ${this.state.editingInstance.name}`}*/}
        {/*    open={this.state.editModalOpen}*/}
        {/*    onClose={this.onCloseEditModal}*/}
        {/*    center*/}
        {/*>*/}
        {/*    <BaseForm*/}
        {/*        inputs={this.editFormInputs}*/}
        {/*        onCancel={this.onCloseEditModal}*/}
        {/*        onSubmit={this.handleUpdateCreateSubmission}*/}
        {/*    />*/}
        {/*</BaseModal>*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.campaigns?.data || [],
  focusedCampaign: state.session.focusedCampaign,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ScriptEdit));

/*
* Speech
Question
Open Question
Phone
Email
Signature
Barcode
Image
*
* */

const sampleData = {
  id: '17',
  name: 'Missourians for Healthcare',
  script_elements: [
    {
      element_id: 227,
      display_name: 'START',
      element_hash: 'start',
      pos_top: 1015.0,
      pos_left: 990.0,
      prompt: '',
      elementtype: 'start',
      connectors: [
        {
          ordinal_position: 1,
          next_el: 228,
          next_el_display_name: 'Scan Barcode',
          next_el_hash: 'u949c',
        },
      ],
      response_count: 0,
    },
    {
      element_id: 228,
      display_name: 'Scan Barcode',
      element_hash: 'u949c',
      pos_top: 1147.0,
      pos_left: 1041.0,
      prompt: '',
      elementtype: 'barcode',
      connectors: [
        {
          ordinal_position: 1,
          next_el: 229,
          next_el_display_name: 'Line Number',
          next_el_hash: '7ietk',
        },
      ],
      response_count: 0,
    },
    {
      element_id: 229,
      display_name: 'Line Number',
      element_hash: '7ietk',
      pos_top: 1300.0,
      pos_left: 1100.0,
      prompt: '',
      elementtype: 'question',
      connectors: [
        {
          ordinal_position: 1,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '1',
        },
        {
          ordinal_position: 2,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '2',
        },
        {
          ordinal_position: 3,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '3',
        },
        {
          ordinal_position: 4,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '4',
        },
        {
          ordinal_position: 5,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '5',
        },
        {
          ordinal_position: 6,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '6',
        },
        {
          ordinal_position: 7,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '7',
        },
        {
          ordinal_position: 8,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '8',
        },
        {
          ordinal_position: 9,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '9',
        },
        {
          ordinal_position: 10,
          next_el: 230,
          next_el_display_name: 'Cell Phone Number',
          next_el_hash: '7rooe',
          value_text: '10',
        },
      ],
      response_count: 0,
    },
    {
      element_id: 230,
      display_name: 'Cell Phone Number',
      element_hash: '7rooe',
      pos_top: 1469.0,
      pos_left: 1438.0,
      prompt: 'Enter voters cell phone number for campaign updates.',
      elementtype: 'phone',
      connectors: [],
      response_count: 0,
    },
  ],
};
